// src/components/HelmetMeta.tsx
import React from "react";
import { Helmet } from "react-helmet";

type HelmetMetaProps = {
  title: string;
  description: string;
  image: string;
};

const HelmetMeta: React.FC<HelmetMetaProps> = ({ title, description, image }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="400" />
      <meta property="og:image:height" content="250" />
    </Helmet>
  );
};

export default HelmetMeta;